import React from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Layouts = ({ children }) => {
    const location = useLocation();
    const isAdminRoute = location.pathname.startsWith("/dashboard-ecobag-secure");

    return (
        <div className="relative min-h-screen overflow-x-hidden w-full bg-green-50">
            {/* <ChatWidget /> */}
            <ToastContainer position="bottom-right" />
            {!isAdminRoute && <Navbar />}
            <main className="w-full max-w-[100vw]">
                <div
                    className={`mx-auto max-w-screen-2xl ${!isAdminRoute ? "px-4 sm:px-6 lg:px-8" : ""
                        }`}
                >
                    {/* <EcoModal /> */}
                    {children}
                </div>
            </main>
            {!isAdminRoute && <Footer />}
        </div>
    );
};

export default Layouts